import React from 'react';
import "./WeAreYMC.css";
import NavBar from '../Layouts/NavBar';
//import { BrowserView, MobileView, isBrowser, isMobile } from 'react-device-detect';
import Footer from '../Layouts/Footer';
import WeAreYMC from './WeAreYMC';

function WeAreYMCRoute() {
    return (
 
            <div className="WeAreYMCRoutePage">
                <div className="WeAreYMCRouteNavBar">      
                        <NavBar/>
                     </div>
                <div className="WeAreYMCRoute">
                    <WeAreYMC/>
                </div>
                <div className="WeAreYMCContact">
                    <Footer/>
                </div>
            </div>

    );
}

export default WeAreYMCRoute;